import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HrListTermTypesPathParameters } from 'api/actions/hr-list-term-types/hr-list-term-types-path-parameters';
import { HrListTermTypesResponse } from 'api/actions/hr-list-term-types/hr-list-term-types-response';

type HrListTermTypesQueryParameters = Record<string, any>;

/**
 * The path of the HrListTermTypes action.
 */
export const hrListTermTypesActionPath = new SweetPath<keyof HrListTermTypesPathParameters>('/api/hr/term-types', {
  path: '{param}',
});

/**
 * Creates a contextualized HrListTermTypes actions.
 */
export default function createHrListTermTypesAction(axios: AxiosInstance) {
  return function hrListTermTypesAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: HrListTermTypesQueryParameters } = {}) {
    const path = hrListTermTypesActionPath.original;

    return axios.request<HrListTermTypesResponse, HrListTermTypesResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
